import { updateCart } from '@/clients/storefront/cartService';
import Button, {
  type ButtonProps,
  ButtonSize,
} from '@/components/BaseLibrary/Button/Button';
import useSunrunShopStore from '@/data-store/hooks/useSunrunShopStore';

function BuyButton({
  variantId,
  ...props
}: ButtonProps & {
  variantId: string | undefined;
}) {
  const { selectedQuantity } = useSunrunShopStore('selectedQuantity');

  const handleClick = async () => {
    if (!variantId) return;

    const newCart = await updateCart(null, {
      merchandiseId: variantId,
      quantity: selectedQuantity,
    });

    if (newCart) {
      const { cart } = newCart;
      if (cart?.checkoutUrl) {
        const url = new URL(cart.checkoutUrl);
        url.searchParams.append('utm_source', location.pathname);

        window.location.href = url.toString();
      }
    }
  };

  return (
    <Button
      {...props}
      disabled={!variantId}
      onClick={handleClick}
      size={{ xs: ButtonSize.SM, md: ButtonSize.MD }}
    />
  );
}

export default BuyButton;
